module.exports = __webpack_public_path__ + "img/icon-user-grey.7c0c3a15.svg";